import Vue from 'vue';
import {
  ValidationProvider,
  ValidationObserver,
  configure,
  extend,
  setInteractionMode,
} from 'vee-validate';
import { required, regex, email, confirmed } from 'vee-validate/dist/rules';
import i18n from '@/i18n';
import moment from 'moment';
import validator from 'validator';

Vue.component('ValidationProvider', ValidationProvider);
Vue.component('ValidationObserver', ValidationObserver);

setInteractionMode('eager');

configure({
  defaultMessage: (_, values: any) =>
    i18n.t(`validation.error.${values._rule_}`, values).toString(), // will use validation.___ as the base lookup in i18n
});

// Add rules
extend('required', required);
extend('regex', regex);
extend('email', email);
extend('confirmed', confirmed);
extend('date', (value) => {
  if (!value) {
    return true;
  }
  return moment(value, 'YYYY-MM-DDTHH:mm:ssZ', true).isValid();
});
extend('password', (value) => {
  if (!value) {
    return true;
  }

  const hasLower = value.match(/[a-z]/);
  const hasUpper = value.match(/[A-Z]/);
  const hasDigit = value.match(/[0-9]/);

  return value.length >= 8 && hasLower && hasUpper && hasDigit;
});
extend('url', (value) => {
  if (!value) {
    return true;
  }
  return validator.isURL(value);
});
